import { Directive, ElementRef, Inject, Injector } from "@angular/core";
import { UpgradeComponent } from "@angular/upgrade/static";

@Directive({
    standalone: false,
    selector: 'farm-select'
})
export class Ng1FarmSelectComponentWrapper extends UpgradeComponent {
    constructor(@Inject(ElementRef) elementRef: ElementRef,@Inject(Injector) injector: Injector){
        super('farmSelect',elementRef,injector);
    }
}